import { usePopperTooltip } from "react-popper-tooltip";
import { FaFileDownload } from "react-icons/fa";
import { FaFileZipper } from "react-icons/fa6";
import useApiClient from "../../hooks/useApiClient";
import { prepDataSetDownloadURL } from "../../apiUtils/downloadUrls";
import { useState } from "react";
// @ts-ignore -- react-toastify package.json exports issue
import { toast } from "react-toastify";

export const ArchiveDownloadOption = ({ dataSet }: { dataSet: any }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();

  return (
    <>
      <a ref={setTriggerRef} href={prepDataSetDownloadURL(dataSet)}>
        <button className="ox-button w-26 mt-2 px-2 py-1">
          <FaFileZipper className="mr-3.5 align-middle" />
          Archive
        </button>
      </a>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container text-sm" })}
        >
          <p>
            Download a single ZIP file containing all assets in this data set
          </p>
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
        </div>
      )}
    </>
  );
};

export const GenerateArchiveOption = ({ dataSet, refreshQuery }: { dataSet: any; refreshQuery?: () => void }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();

  const api = useApiClient();
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = async () => {
    setIsDisabled(true);
    toast(
      "Your request has been received! It will be available for download shortly."
    );
    await api.job.submitJobCreateDataSetArchiveExport({
      requestBody: {
        data_set_public_id: dataSet.public_id,
      },
    });
    refreshQuery?.();
  };

  return (
    <>
      <a ref={setTriggerRef} onClick={handleClick} onMouseEnter={refreshQuery}>
        <button className="ox-button w-26 mt-2 px-2 py-1" disabled={isDisabled}>
          <FaFileDownload className="mr-4 align-middle" />
          Request Export
        </button>
      </a>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container text-sm" })}
        >
          <p>
            An export of this data set is not currently available for download
            but you can click here to request an export.
          </p>
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
        </div>
      )}
    </>
  );
};

export const ArchiveIsGeneratingNonOption = ({ dataSet, refreshQuery }: { dataSet: any; refreshQuery?: () => void }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();

  return (
    <>
      <a ref={setTriggerRef} onMouseEnter={refreshQuery}>
        <button disabled className="ox-button w-26 mt-2 px-2 py-1">
          <FaFileDownload className="mr-4 align-middle" />
          Generating Archive
        </button>
      </a>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container text-sm" })}
        >
          <p>
            Files archived:{" "}
            {dataSet.export.full_export_job.status_detail.processed_assets.toLocaleString()}{" "}
            of{" "}
            {dataSet.export.full_export_job.status_detail.total_number_of_assets.toLocaleString()}
          </p>
          <p></p>
          <div {...getArrowProps({ className: "tooltip-arrow" })} />
        </div>
      )}
    </>
  );
};
